import { Injectable } from '@angular/core';
import { FeatureFlagsService } from '@skylab-angular-shared/config';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { UserLicensesQuery, UserLicensesQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UserLicensesQuery)
@Wrapper(UserLicensesQueryHandlerBase)
export class UserLicensesQueryHandler {
    public constructor(
        http: Http,
        featureFlags: FeatureFlagsService
    ) { }
}
